import {
    RxDocument,
    RxJsonSchema
} from 'rxdb';
import { Point } from '../models';

export type PointDoc = RxDocument<Point, {}>

export const pointSchema: RxJsonSchema<Point> = {
    title: 'point schema',
    //description: 'describes a simple hero',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true
        },
        latitude: { type: ['number','null'] },
        longitude: { type: ['number','null'] },
        buildingId: { type: 'string' },
        public: { type: 'boolean' },
        civicAddress: { type: ['string', 'null'] },
        floorNum: { type: ['string', 'null'] },
        floorName: { type: ['string', 'null'] },
        quadrant: { type: ['string', 'null'] },
        type: { type: ['string', 'null'] },
        distFromWindow: { type: ['string', 'null'] },
        floorAndDescript: { type: ['string', 'null'] },
        locationDescription: { type: ['string', 'null'] },
        wRef1: { type: ['string', 'null'] },
        wRef2: { type: ['string', 'null'] },
        geoid: { type: ['string', 'null'] },
        altitudeGeoidMeters: { type: ['number', 'null'] },
        wgs84: { type: ['string', 'null'] },
        altitudeEllipsoidMeters: { type: ['number', 'null'] },
        windowCnt: { type: ['string', 'null'] },
        floorToCeilingFtIn: { type: ['string', 'null'] },
        clutter: { type: ['string', 'null'] },
        hvac: { type: ['string', 'null'] },
        stage1: { type: ['string', 'null'] },
        stage2: { type: ['string', 'null'] },
        stage1a: { type: ['string', 'null'] },
        stage1b2a: { type: ['string', 'null'] },
        stageDl: { type: ['string', 'null'] },
        stageZ: { type: ['string', 'null'] },
        stage1c: { type: ['string', 'null'] },
        stageZa: { type: ['string', 'null'] },
        stage1d: { type: ['string', 'null'] },
        comments: { type: ['string', 'null'] },

        stage1eZb : { type: ['string', 'null'] },
        class : { type: ['number', 'null'] },
        usability : { type: ['string', 'null'] },
        updatedAt: { type: 'number' }
    },
    required: ['_id', 'latitude', 'longitude'],
    indexes: [ 'buildingId', 'updatedAt']
};


const pointFields = [ ...Object.keys(new Point()), 'deleted' ]


export const pointPullQueryBuilder = () => {
    return (doc) => {
        if (!doc) {
            doc = {...new Point(), deleted: false }
        }

        const query = `{ feedForRxdbPoints(lastId: "${doc._id}", minUpdatedAt: ${doc.updatedAt}){ ${pointFields.join(' ')} } }`;
        return {
            query,
            variables: {}
        };
    };
};


//Need to have shared schema with server for this to work
export const graphQLGenerationInput = {
    allPoints: {
        schema: pointSchema,
        feedKeys: [
            '_id',
            'buildingId',
            'updatedAt'
        ],
        deletedFlag: 'deleted'
    }
}